import { VALIDATION_ERROR_MESSAGES } from 'utils/globalVariable';

const FIELD_MAPPINGS = {
  title: {
    valuePath: 'title',
    validate: (value) => !!value,
  },
  location: {
    valuePath: 'locationIds',
    validate: (value) => value?.[0],
  },
};

export const validateTask = (
  taskSettings,
  task,
  errors,
  setErrors,
  skipValidations,
) => {
  const { title, location } = taskSettings?.fields || {};
  let hasErrors = false;
  const newErrors = { ...(errors ?? {}) };

  const validations = [
    {
      field: 'title',
      required: title?.required,
      value: task?.title,
      errorMessage: VALIDATION_ERROR_MESSAGES.TASK_TITLE_REQUIRED,
      validate: (value) => !!value,
    },
    {
      field: 'location',
      required: location?.required,
      value: task?.locationIds,
      errorMessage: VALIDATION_ERROR_MESSAGES.TASK_LOCATION_REQUIRED,
      validate: (value) => value?.[0],
    },
  ];

  validations.forEach(({ field, required, value, errorMessage, validate }) => {
    if (!skipValidations?.[field] && required && !validate(value)) {
      hasErrors = true;
      newErrors[field] = errorMessage;
    }
  });

  if (hasErrors) {
    setErrors(newErrors);
  }

  return hasErrors;
};

export const removeTaskError = (task, errors, setErrors) => {
  const newErrors = { ...(errors ?? {}) };
  let hasChanges = false;

  Object.entries(FIELD_MAPPINGS).forEach(([field, config]) => {
    const value = task?.[config.valuePath];
    if (config.validate(value) && newErrors[field]) {
      delete newErrors[field];
      hasChanges = true;
    }
  });

  if (hasChanges) {
    setErrors(newErrors);
  }
};
